import { z } from 'zod'

export interface InviteProps {
  inviteModalVisible: boolean
  setInviteModalVisible: (visible: boolean) => void
  inviteIsFetching: boolean
  selectedProgramYear: number
}

export type FormValues = {
  name: string
  email: string
}

export const UserInviteSchema = z
  .object({
    name: z.string().min(1, 'Name is required'),
    email: z
      .string()
      .email('Invalid email address')
      .optional()
      .or(z.literal('')),
  })
  .refine((data) => data.email, {
    message: 'Email is required',
    path: ['email'],
  })

export type UserInviteFormValues = z.infer<typeof UserInviteSchema>
